<template>
  <div>
    <v-app-bar
      :color="!isScrolling ? 'transparent' : '#084776'"
      :flat="!isScrolling"
      app
      dark
      height='80px'
      v-scroll="onScroll"
    >
      <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
        <!-- <v-icon>fas fa-address-card</v-icon> -->
        <v-row>
          <router-link style="text-decoration:none; color: white" to="/">
            <v-col>
              <a style="text-decoration:none; color: white" @click="scrollToTop()">
                <v-img class="mt-3" style="width: 180px" :src="require('@/assets/img/logo-sumarum-white.png')"></v-img>
              </a>
            </v-col>
          </router-link>
        </v-row>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items v-if="$vuetify.breakpoint.mdAndUp" class="hidden-sm-and-down">
        <v-btn
          v-for="(item, i) in items"
          :active-class="!isScrolling ? 'primary--text' : undefined"
          :key="i"
          color="transparent"
          elevation="0"
          :href="item.link"
          @click="scrollToTop()"
        >
          <span v-text="item.text" v-if="!item.meni"></span>
          <v-menu offset-y v-else open-on-hover dark>
            <template v-slot:activator="{ on }">
              <span v-text="item.text" v-on="on"></span>
            </template>
            <v-list style="background-color: rgba(8,71,118,0.7)">
              <div v-for="(x, index) in item.meni" :key="index">
                <v-list-item v-if="x.link.slice(0,4) != 'http' " :to="x.link">
                  <v-list-item-title style="color: white">{{ x.text }}</v-list-item-title>
                </v-list-item>
                <v-list-item v-else :href="x.link" target="_blank">
                  <v-list-item-title style="color: white">{{ x.text }}</v-list-item-title>
                </v-list-item>
              </div>
            </v-list>
          </v-menu>
        </v-btn>
      </v-toolbar-items>
      <v-toolbar-items class="hidden-md-and-up">
        <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      </v-toolbar-items>
    </v-app-bar>

    <v-navigation-drawer
      temporary
      class="hidden-md-and-up"
      app
      right
      light
      :value="drawer"
      v-model="drawer"
    >
      <v-layout>
        <v-flex xs12>
          <img class="pa-3" style="height: 80px;" src="../assets/img/logo.png" />
        </v-flex>
      </v-layout>
      <v-divider></v-divider>
      <v-list class="pa-1" v-for="(stavka, i) in items" :key="i">
        <v-list-item color="#084776">
          <a class="drower-link" v-if="stavka.link.startsWith('https://')" :href="stavka.link">
            <v-list-item-title>{{stavka.text}}</v-list-item-title>
          </a>
          <router-link v-else :to="stavka.link" class="drower-link">
            <v-list-item-title>
              <a class="drower-link" @click="scrollToTop()">{{stavka.text}}</a>
            </v-list-item-title>
          </router-link>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-fade-transition mode="out-in">
      <v-img
        :height="'60vh'"
        :src="require('@/assets/img/Cover1.png')"
        class="white--text"
        gradient="to top, rgba(13, 3, 29, .60), rgba(25, 25, 38, .30)"
      >
        <v-fade-transition mode="out-in">
          <v-container fill-height>
            <v-row align="center">
              <v-fade-transition mode="out-in">
                <v-col class="text-center">
                  <img
                    :src="require('@/assets/img/sum-icon.svg')"
                    style="width: 80px"
                    class="hidden-md-and-up"
                  />
                  <img
                    :src="require('@/assets/img/sum-icon.svg')"
                    style="width: 130px"
                    class="hidden-sm-and-down"
                  />

                  <h1 class="display-2 hidden-sm-and-down">Portal za e-učenje Sveučilišta u Mostaru</h1>
                  <h1 class="headline hidden-md-and-up">Portal za e-učenje Sveučilišta u Mostaru</h1>
                  <div
                    class="subheading hidden-sm-and-down"
                  >Dobrodošli na portal e-učenja Sveučilišta u Mostaru. Ovdje možete pratiti sve novosti vezane za e-učenje.</div>
                  <div
                    class="body-1 hidden-md-and-up"
                  >Dobrodošli na portal e-učenja Sveučilišta u Mostaru. Ovdje možete pratiti sve novosti vezane za e-učenje.</div>
                </v-col>
              </v-fade-transition>
            </v-row>
          </v-container>
        </v-fade-transition>
      </v-img>
    </v-fade-transition>
  </div>
</template>

<script>
export default {
  methods: {
    onScroll() {
      this.isScrolling =
        (window.pageYOffset || document.documentElement.scrollTop || 0) > 100;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    }
  },
  data: () => ({
    drawer: false,
    isScrolling: false,
    items: [
      {
        link: "/",
        text: "Naslovnica"
      },
      {
        link: "/novosti",
        text: "Novosti"
      },
      {
        link: "/prirucnici",
        text: "Priručnici i upute za korištenje",
        // meni: [
        //   {
        //     link: "https://eucenje.sum.ba/Prirucnik/mobile/index.html#p=1",
        //     text: "Moodle džepni priručnik"
        //   },
        //   {
        //     link: "https://eucenje.sum.ba/Prirucnik/prirucnik-nastavnici.pdf",
        //     text: "Priručnik za nastavnike"
        //   },
        //   {
        //     link: "https://eucenje.sum.ba/Prirucnik/prirucnik-studenti.pdf",
        //     text: "Priručnik za studente"
        //   },
        //   {
        //     link: 'https://web-admin.sum.ba/api/storage/Upute%20za%20kreiranje%20e%20kolegija_1579595159_42.pdf',
        //     text: 'Upute za kreiranje e-kolegija'
        //   },
        //   {
        //     link: 'https://eucenje.sum.ba/Prirucnik/Prepruke-za-obrazovne-materijale-u-otvorenom-pristupu.pdf',
        //     text: 'Prepruke za obrazovne materijale'
        //   },
        //   {
        //     link: 'https://eucenje.sum.ba/Prirucnik/Prirucnik-za-izradu-testova-u-sustavu-SUMARUM.pdf',
        //     text: 'Priručnik za izradu testova'
        //   },
        //   {
        //     link: 'https://eucenje.sum.ba/Prirucnik/Upute-za-pristup-online-tecajevima-u-sustavu-SUMARUM.pdf',
        //     text: 'Upute za pristup online tečajevima'
        //   },
        //   {
        //     link: 'https://www.youtube.com/watch?v=C2zcvYh5FRE',
        //     text: 'Organizacija i sadržaj e-kolegija'
        //   },
        //   {
        //     link: 'https://www.youtube.com/channel/UCzjzEJSfK2fuBkitcDV5-0w',
        //     text: 'Video upute'
        //   }
        // ]
      },
      {
        link: "https://eucenje.sum.ba/moodle/login/login.php",
        text: "Prijava"
      }
    ]
  })
};
</script>

<style>
</style>
